import React, { Component } from "react";
import ExperienceCard from "../../components/experienceCard/ExperienceCard.js";
import "./ExperienceAccordion.css";
import { Accordion, Panel } from "baseui/accordion";

class ExperienceAccordion extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="experience-accord ">
        <Accordion>
          {this.props.sections.map((section) => {
            return (
              <Panel
                className="accord-panel"
                title={section["title"]}
                key={section["title"]}
                overrides={{
                  Header: {
                    style: () => ({
                      backgroundColor: `${theme.body}`,
                      border: `1px solid`,
                      borderRadius: `10px`,
                      borderColor: `${theme.body}`,
                      marginBottom: `3px`,
                      marginTop: `10px`,
                      fontFamily: "Google Sans Regular",
                      color: `${theme.text}`,

                      ":hover": {
                        color: `${theme.secondaryText}`,
                      },
                      ":focus": {
                        backgroundColor: `#0D0D27`,
                        borderBottomLeftRadius: "0px",
                        borderTopLeftRadius: "0px",
                        border: `#0D0D27 solid 1px`,
                        borderLeft: `${theme.text} solid 1px`,
                      },
                    }),
                  },
                  Content: {
                    style: () => ({
                      backgroundColor: `${theme.body}`,
                    }),
                  },
                  ToggleIcon: {
                    style: () => ({
                      color: `${theme.text}`,
                      outline: `${theme.text} solid 1.5px`,
                      borderRadius: "50%",
                    }),
                  },
                }}
              >
                {section["experiences"].map((experience, index) => {
                  return (
                    <ExperienceCard
                      index={index}
                      totalCards={section["experiences"].length}
                      experience={experience}
                      theme={theme}
                    />
                  );
                })}
              </Panel>
            );
          })}
        </Accordion>
      </div>
    );
  }
}

export default ExperienceAccordion;
